module.exports = __webpack_public_path__ + "img/rindfleischganbianmithintergrund.b34b2a89.jpg";